import { computed } from '@nuxtjs/composition-api';
import * as ArticleConstants from '@/constants/ArticleCardsConstants';

export default function useArticleCards (articleCards) {
  const articleIndexList = computed(() => {
    const indexList = []
    let index = 0;
    for (let i = 0; i < articleCards?.value?.length; i++) {
      indexList.push(ArticleConstants.PLACE_CARD_AFTER + index)
      index += ArticleConstants.PLACE_CARD_AFTER + 1
    }
    return indexList
  })
  return {
    articleIndexList
  }
}
